const snackDefaultOptions: Snack.SnackInput = {
  life: 3000,
};

export default snackDefaultOptions;
